import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button, PopupFooter } from '@gem/ui-kit';

import { SelectContacts } from 'APP/components/SelectContacts/SelectContacts';
import { GroupType } from 'APP/model/group/groupModel.types';

import { useGroupFormMembersPresenter } from './GroupFormMembers.presenter';

interface IGroupFormMembersProps {
  membersIds: string[];
  targetGroupType: GroupType;
  onSetMembersIds(membersIds: string[]): void;
  onNextStep(): void;
}

export const GroupFormMembers: FC<IGroupFormMembersProps> = observer((props) => {
  const { membersIds, onSetMembersIds, onNextStep, targetGroupType } = props;

  const { t } = useTranslation();
  const presenter = useGroupFormMembersPresenter();

  return (
    <>
      <SelectContacts
        isLoading={presenter.isLoading}
        contacts={presenter.candidates}
        loadMore={presenter.loadMore}
        hasMore={presenter.hasMore}
        selectedContactsIds={membersIds}
        setSelectedIds={onSetMembersIds}
        targetGroupType={targetGroupType}
      />
      <PopupFooter>
        <Button
          onClick={onNextStep}
          theme="primary"
        >
          {t('group_chat_continue_button')}
        </Button>
      </PopupFooter>
    </>
  );
});
